import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=d4da64de&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=d4da64de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4da64de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4da64de')) {
      api.createRecord('d4da64de', component.options)
    } else {
      api.reload('d4da64de', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=d4da64de&scoped=true&", function () {
      api.rerender('d4da64de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2sB2zUG35Vjz7/JS/comp/SearchFilterTokens.vue"
export default component.exports